import { format, parseISO } from 'date-fns';
import { dates } from '@/api';

/* eslint no-param-reassign: ["error"] */
const currentState = {
  availableDates: [],
  availableDatesByDate: [],
};

const mutations = {
  set_available_dates(state, { availableDates }) {
    state.availableDates = availableDates;
  },
  set_available_dates_by_date(state, { availableDatesByDate }) {
    state.availableDatesByDate = availableDatesByDate;
  },
};

const actions = {
  async getAvailableDates({ commit, rootState }) {
    try {
      const bookingDates = await dates.all({
        filter: {
          supplier_id: rootState.auth.user.supplier.id,
        },
      })
      commit('set_available_dates', { availableDates: bookingDates.data() });
      //commit('set_available_dates_by_date', { availableDatesByDate: data.availableDatesByDate });
    } catch ({ response }) {
      console.log(response);
    }
  },
};

const getters = {
  availableDates: state => state.availableDates,
  availableDatesByDate: state => Object.entries(state.availableDatesByDate).reverse(),
  calendarDates: state => state.availableDates.map(date => ({
    key: date.id,
    dates: parseISO(date.starts_at),
    customData: {
      id: date.id,
      title: `<strong>${format(parseISO(date.starts_at), 'HH:mm')}</strong> ${
        date.variation_name
      } (${date.bookings.length} av ${date.participants})`,
      class: 'bg-primary text-white',
      participants: date.participants,
      participants_left: date.participants_left
    },
  })),
};

export default {
  namespaced: true,
  state: currentState,
  getters,
  actions,
  mutations,
};
